import type { WpisUwagi } from "../../lib/uwagiWypowiedzi.js";
import { Card } from "../ui/Card.js";
import { ListaUwag } from "./ListaUwag.js";

/**
 * "Uwagi do calej rozmowy": uwagi bez wypowiedzi (numer null) albo z numerem, ktorego w transkrypcie nie ma. Od zmiany
 * widoku nowe uwagi powstaja tylko przy wypowiedziach, wiec w zwyklej rozmowie tej karty nie ma. Kontrakt nadal dopuszcza
 * takie rekordy, a recenzent ma je moc poprawic albo usunac (te same "Edytuj" i "Usun" co przy wypowiedzi), wiec karta
 * pojawia sie tylko wtedy, gdy jakies sa.
 */
export function KartaUwagDoRozmowy({ wpisy }: { wpisy: readonly WpisUwagi[] }): React.JSX.Element | null {
  if (wpisy.length === 0) return null;
  return (
    <Card tytul="Uwagi do całej rozmowy">
      <p className="field-hint rec-uwagi-ogolne__opis">Uwagi, które nie dotyczą żadnej konkretnej wypowiedzi.</p>
      <ListaUwag wpisy={wpisy} />
    </Card>
  );
}
